// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-dialog-public-author-section {
  width: 100%;
  flex-shrink: 0;
  padding: 24px 0;
  border-style: solid;
  border-width: 1px 0;
  border-color: var(--g-color-line-generic-solid);
  margin-top: 24px;
}
.dl-dialog-public-author-section__title {
  font-weight: 500;
  margin-bottom: 4px;
  font-size: var(--g-text-body-2-font-size);
}
.dl-dialog-public-author-section__description {
  margin-top: 4px;
  color: var(--g-color-text-secondary);
  line-height: var(--g-text-caption-2-line-height);
}
.dl-dialog-public-author-section__form {
  margin-top: 12px;
}
.dl-dialog-public-author-section__form-row {
  --gc-form-row-label-width: 120px;
  margin-bottom: 12px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/EntryDialogues/DialogSwitchPublic/DialogPublic/AuthorSection/AuthorSection.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,+CAAA;EACA,gBAAA;AACJ;AACI;EACI,gBAAA;EACA,kBAAA;EACA,yCAAA;AACR;AAEI;EACI,eAAA;EACA,oCAAA;EACA,gDAAA;AAAR;AAGI;EACI,gBAAA;AADR;AAII;EACI,gCAAA;EACA,mBAAA;AAFR","sourcesContent":[".dl-dialog-public-author-section {\n  width: 100%;\n  flex-shrink: 0;\n  padding: 24px 0;\n  border-style: solid;\n  border-width: 1px 0;\n  border-color: var(--g-color-line-generic-solid);\n  margin-top: 24px;\n}\n.dl-dialog-public-author-section__title {\n  font-weight: 500;\n  margin-bottom: 4px;\n  font-size: var(--g-text-body-2-font-size);\n}\n.dl-dialog-public-author-section__description {\n  margin-top: 4px;\n  color: var(--g-color-text-secondary);\n  line-height: var(--g-text-caption-2-line-height);\n}\n.dl-dialog-public-author-section__form {\n  margin-top: 12px;\n}\n.dl-dialog-public-author-section__form-row {\n  --gc-form-row-label-width: 120px;\n  margin-bottom: 12px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
